module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/人才培养.841d5b94.png";